import React from 'react';
import './PeriodTag.scss';
import PeriodService from 'shared/services/PeriodService';

interface PeriodTagProps {
    period: string;
    line?: boolean;
}

export default function PeriodTag({ period, line }: PeriodTagProps) {
    const p = period.toLowerCase();
    const tag = (
        <div className={`period-tag --${p}`}>
            {PeriodService.getPeriod(p) ||
                PeriodService.getPeriod('noon')}
        </div>
    );

    return line ? (
        <div className={`period-tag-wrapper --${p}`}>{tag}</div>
    ) : (
        tag
    );
}
